import React__default from 'react';
import { getRemValue } from '../../methods/getRemValue.js';
import { getHeightByViewPort } from '../../methods/getSizeByViewPort.js';
import 'bowser';
import '../../_virtual/_tslib.js';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import '../../constants/serviceTypeId.js';
import '../../constants/StateList.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import '../../_services/const.js';
import '../toast/toast.js';
import '../../_services/auth.service.js';
import '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';

const ValidationError = ({ errorClass, error, style = {} }) => {
    return (React__default.createElement("div", { style: Object.assign({ 
            // height: "11px",
            color: "#FF1224", fontSize: getRemValue(11), lineHeight: getHeightByViewPort(10) }, style), className: errorClass }, error));
};

export { ValidationError as default };
//# sourceMappingURL=ValidationError.js.map
